export const LOAD_AGREEMENTS_SUCCESS = 'LOAD_AGREEMENTS_SUCCESS';

export const NEW_AGREEMENT_SUCCESS = 'NEW_AGREEMENT_SUCCESS';

export const CREATE_AGREEMENT_SUCCESS = 'CREATE_AGREEMENT_SUCCESS';

export const EDIT_AGREEMENT_SUCCESS = 'EDIT_AGREEMENT_SUCCESS';

export const UPDATE_AGREEMENT_SUCCESS = 'UPDATE_AGREEMENT_SUCCESS';

export const DELETE_AGREEMENT_SUCCESS = 'DELETE_AGREEMENT_SUCCESS';

export const CHECK_DELETE_AGREEMENT_SUCCESS = 'CHECK_DELETE_AGREEMENT_SUCCESS';

export const UPDATE_PHOTOGRAPHER_AGREEMENT_SUCCESS = 'UPDATE_PHOTOGRAPHER_AGREEMENT_SUCCESS';
